import { motion } from "framer-motion";
import { ShieldCheck, Package, Truck, Handshake, Flag } from "lucide-react";

/**
 * TrustStrip — full-width dark bar directly below the hero showing the
 * 5 core credentials of SBC Ltd. Two-line labels styled like Coca-Cola /
 * PepsiCo / Danone trust bars.
 */
const ITEMS = [
  { Icon: ShieldCheck, title: "Developed by SBC Ltd", sub: "British Quality" },
  { Icon: Package,     title: "Manufactured to",      sub: "International Standards" },
  { Icon: Truck,       title: "Export Ready",         sub: "Global Markets" },
  { Icon: Handshake,   title: "Distributor Opportunities", sub: "Available" },
  { Icon: Flag,        title: "Made in the United Kingdom", sub: "Proudly British" },
];

export default function TrustStrip() {
  return (
    <section
      className="bg-neutral-950 border-y border-white/5 py-6"
      data-testid="trust-strip"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 gap-y-8 items-center">
          {ITEMS.map(({ Icon, title, sub }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: 0.05 * i }}
              className="flex items-center gap-3 text-white"
              data-testid={`trust-item-${i}`}
            >
              <div className="w-10 h-10 rounded-full bg-gold-400/10 border border-gold-400/25 flex-none flex items-center justify-center">
                <Icon className="w-4 h-4 text-gold-400" />
              </div>
              <div className="min-w-0">
                <div className="font-semibold text-[13px] leading-tight">{title}</div>
                <div className="text-[11px] text-neutral-400 mt-0.5">{sub}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
